






















































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { SmartQuery } from 'vue-apollo-decorator';
import { UNIT_INVOICE_SETTINGS } from '@/queries/CompanySetting';
import { GQL_unitInvoiceSetting_currentUnit_unitSetting_unitInvoiceSetting } from '@/queries/__generated__/unitInvoiceSetting';
import InvoiceOverdueNoticesForm from './InvoiceOverdueNoticesForm.vue';
import InvoiceOverdueNoticeMailButton from './InvoiceOverdueNoticeMailButton.vue';
import InvoiceOverdueNoticesLogs from './InvoiceOverdueNoticesLogs.vue';
import ShowPdfButton from '../../Shared/Buttons/ShowPdfButton.vue';
import { GQL_invoice_invoice } from '@/queries/__generated__/invoice';
import gql from 'graphql-tag';

const INVOICE_OVERDUE_NOTICE_PDF = gql`
  query invoiceOverdueNotice($id: ID!) {
    invoiceOverdueNotice(id: $id) {
      id
      pdf {
        id
        url
      }
    }
  }
`;

@Component({
  components: {
    InvoiceOverdueNoticesForm,
    InvoiceOverdueNoticeMailButton,
    InvoiceOverdueNoticesLogs,
    ShowPdfButton,
  },
})
export default class InvoiceOverdueNoticesList extends Vue {
  @Prop() private invoice!: GQL_invoice_invoice;
  @SmartQuery(UNIT_INVOICE_SETTINGS) private currentUnit!: GQL_unitInvoiceSetting_currentUnit_unitSetting_unitInvoiceSetting;

  private INVOICE_OVERDUE_NOTICE_PDF = INVOICE_OVERDUE_NOTICE_PDF;

  private get invoiceIsOverdue(): boolean {
    return this.$dayjs().isSameOrAfter(this.invoice.dueDate);
  }
}
